var _g, _path, _g2, _circle, _circle2, _g3, _circle3, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 49,
    viewBox: "0 0 204 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5781_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 36L35.677 17.6566C36.3074 17.2533 37.1103 17.2358 37.7577 17.6111L51.4932 25.5734C52.3957 26.0966 53.5488 25.8382 54.1418 24.9798L66.5278 7.04932C67.2545 5.99724 68.7683 5.88799 69.6386 6.82482L87.323 25.8612C87.7014 26.2686 88.2323 26.5 88.7883 26.5H98.7406C99.3445 26.5 99.9161 26.7729 100.296 27.2424L105.935 34.2159C106.697 35.1591 108.118 35.2117 108.948 34.3273L111.834 31.2536C112.511 30.5328 113.613 30.4147 114.427 30.9758L129.096 41.0856C129.871 41.6193 130.913 41.5413 131.599 40.898L142.112 31.0443C142.77 30.4277 143.759 30.3275 144.527 30.7997L156.572 38.2038C156.887 38.3975 157.25 38.5 157.619 38.5H171.833C172.215 38.5 172.589 38.3906 172.911 38.1848L185.704 30.0013C186.587 29.4368 187.755 29.6489 188.383 30.4876L197 42",
    stroke: "#DD172C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 36L35.677 17.6566C36.3074 17.2533 37.1103 17.2358 37.7577 17.6111L51.4932 25.5734C52.3957 26.0966 53.5488 25.8382 54.1418 24.9798L66.5278 7.04932C67.2545 5.99724 68.7683 5.88799 69.6386 6.82482L87.323 25.8612C87.7014 26.2686 88.2323 26.5 88.7883 26.5H98.7406C99.3445 26.5 99.9161 26.7729 100.296 27.2424L105.935 34.2159C106.697 35.1591 108.118 35.2117 108.948 34.3273L111.834 31.2536C112.511 30.5328 113.613 30.4147 114.427 30.9758L129.096 41.0856C129.871 41.6193 130.913 41.5413 131.599 40.898L142.112 31.0443C142.77 30.4277 143.759 30.3275 144.527 30.7997L156.572 38.2038C156.887 38.3975 157.25 38.5 157.619 38.5H171.833C172.215 38.5 172.589 38.3906 172.911 38.1848L185.704 30.0013C186.587 29.4368 187.755 29.6489 188.383 30.4876L197 42",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 36L35.677 17.6566C36.3074 17.2533 37.1103 17.2358 37.7577 17.6111L51.4932 25.5734C52.3957 26.0966 53.5488 25.8382 54.1418 24.9798L66.5278 7.04932C67.2545 5.99724 68.7683 5.88799 69.6386 6.82482L87.323 25.8612C87.7014 26.2686 88.2323 26.5 88.7883 26.5H98.7406C99.3445 26.5 99.9161 26.7729 100.296 27.2424L105.935 34.2159C106.697 35.1591 108.118 35.2117 108.948 34.3273L111.834 31.2536C112.511 30.5328 113.613 30.4147 114.427 30.9758L129.096 41.0856C129.871 41.6193 130.913 41.5413 131.599 40.898L142.112 31.0443C142.77 30.4277 143.759 30.3275 144.527 30.7997L156.572 38.2038C156.887 38.3975 157.25 38.5 157.619 38.5H171.833C172.215 38.5 172.589 38.3906 172.911 38.1848L185.704 30.0013C186.587 29.4368 187.755 29.6489 188.383 30.4876L197 42",
    stroke: "#DD172C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5781_3306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 192 45)",
    fill: "#DD172C"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 192 45)",
    fill: "#DD172C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 194 43)",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_5781_3306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 4 39)",
    fill: "#DD172C"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 4 39)",
    fill: "#DD172C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1 0 0 -1 6 37)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5781_3306",
    x: 1.5,
    y: 0.685944,
    width: 201,
    height: 46.8141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5781_3306",
    x: 188,
    y: 33,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3306"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5781_3306",
    x: 0,
    y: 27,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3306"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGDown);
export default __webpack_public_path__ + "static/media/gDown.f80c7cd6bfd7ee4dce2bc7b59ad4e5b3.svg";
export { ForwardRef as ReactComponent };